import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!(window as any).fbq) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq = function () {
        (window as any).fbq.callMethod ? (window as any).fbq.callMethod.apply((window as any).fbq, arguments) : (window as any).fbq.queue.push(arguments);
      };
      (window as any).fbq.queue = [];
      (window as any).fbq.loaded = true;
      (window as any).fbq.version = '2.0';
    }
    (window as any).fbq('init', '1235520042121421');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <>
      <style dangerouslySetInnerHTML={{
      __html: `
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=Nunito:wght@300;400;600;700;800&display=swap');
        
        :root {
          --font-heading: 'Syne', sans-serif;
          --font-body: 'Nunito', sans-serif;
        }
        
        .font-heading, h1, h2, h3, h4, h5, h6 {
          font-family: var(--font-heading);
        }
        
        .font-body, body, p, span, div {
          font-family: var(--font-body);
        }
        
        html {
          scroll-behavior: smooth;
        }
      `
    }} data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}